<style>

</style>
<template>


	<v-menu offset-y :closeOnContentClick="false" :closeOnClick="true">
		<template v-slot:activator="{ on }">
			<v-btn x-small text v-on="on">	
				<v-icon>mdi-table-column</v-icon> Columns <v-badge x-small :content="cols" :color="primary"></v-badge>
			</v-btn>
		</template>
		<v-list>
			<v-list-item v-for="size in sizes" :key="size.key" class="pr-7"> 
				<v-list-item-title>
					<small>{{size.title}}</small>
				</v-list-item-title>
					<v-btn icon x-small @click="decrease([size.key])" :disabled="element.attrs[size.key] == 0">
						<v-icon x-small>mdi-minus-circle</v-icon>
					</v-btn>
					<v-btn icon x-small @click="increase([size.key])" :disabled="element.attrs[size.key] == 12">
						<v-icon x-small>mdi-plus-circle</v-icon>
					</v-btn>
					<v-badge  x-small v-if="element.attrs[size.key]" :content="element.attrs[size.key]" :color="primary"></v-badge>
			</v-list-item>
		</v-list>
	</v-menu>

</template>

<script>
	export default {
		name: "EditorColWidths",
		props: ["element"],
		data: () => {
			return {
				sizes: [
					{key: 'cols', title: "Default"},
					{key: 'xs', title: "X-Small"},
					{key: 'sm', title: "Small"},
					{key: 'md', title: "Medium"},
					{key: 'lg', title: "Large"},
				]
			}
		},
		computed: {
			cols(){
				return this.element.attrs.cols
			}
		},
		methods: {
			increase(size){
				this.$emit( "increase", size )
			},
			decrease(size){
				this.$emit( "decrease", size )
			}
		},
		created(){
			this.value = this.current
		}
		
	}
</script>